import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Row, Content } from '../components/Layout'
import Button from '../components/Button'
import '../styles/hero.css'
import Bowser from 'bowser'

let ticking = false

class Hero extends Component {
  initScroll () {
    window.addEventListener('scroll', this.requestTick.bind(this), false)
  }

  requestTick () {
    if (!ticking) {
      window.requestAnimationFrame(this.scrollHandler)
      ticking = true
    }
  }

  scrollHandler () {
    const heroContent = document.getElementById('heroContent')
    const fromTop = window.pageYOffset
    if (fromTop > 300) {
      ticking = false
      return
    }
    if (heroContent !== null) {
      heroContent.style.transform = `translate3d(0, ${(fromTop / 3)}px, 0)`
      heroContent.style.opacity = 1.5 - (fromTop / 200)
    }
    ticking = false
  }

  render () {
    this.initScroll()
    return (
      <div className='main'>
        <div className='mask' />
        <div className='backgroundHex' />
        <div className='backgroundHex' />
        {
          this.props.options !== undefined &&
          this.props.options.background !== undefined &&
          <div id='heroVideo' className='videoBackground' style={{'background': 'url(https://storage.googleapis.com/bronze-labs-static/media/' + this.props.options.background + '.jpg)'}}>
            {
              !Bowser.msie &&
              !Bowser.msedge &&
              <video autoPlay muted playsInline loop poster={'/media/' + this.props.options.background + '.jpg'}>
                <source src={'https://storage.googleapis.com/bronze-labs-static/media/' + this.props.options.background + '.mp4'} type='video/mp4' />
                <source src={'https://storage.googleapis.com/bronze-labs-static/media/' + this.props.options.background + '.webm'} type='video/webm' />
                <source src={'https://storage.googleapis.com/bronze-labs-static/media/' + this.props.options.background + '.ogv'} type='video/ogg' />
              </video>
            }
          </div>
        }
        <div className='heroContainer'>
          <Row>
            <Content id='heroContent'>
              <h1 dangerouslySetInnerHTML={{__html: this.props.options !== undefined && this.props.options.header}} />
              <h3 dangerouslySetInnerHTML={{__html: this.props.options !== undefined && this.props.options.subtext}} />
              {this.props.options !== undefined && this.props.options.buttons !== undefined && <div>
                {this.props.options.buttons.map((button, index) => (
                  <Button key={index} icon={button.icon} text={button.text} href={button.link} target={button.target} />
                ))}
              </div>}
            </Content>
          </Row>
        </div>
      </div>
    )
  }
}

Hero.propTypes = {
  options: PropTypes.object.isRequired
}

export default Hero



// WEBPACK FOOTER //
// ./src/components/Hero.js